export const comments_3357256 = {"data":{"data":[],"links":{}}}